import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import DataSourceProps from './DataSourceProps'

import Filter from './Filter'
import Group from './Group'
import Schema from './Schema'
import Sort from './Sort'
import Transport from './Transport'

export default {
    props: DataSourceProps,
    mixins: [
        KendoBaseComponent,
        Filter,
        Group,
        Schema,
        Sort,
        Transport
    ],
    mounted () {

        this.$watch(
            () => [this.filter, this.filterValue, this.filterField,
                this.filterFilters, this.filterLogic, this.filterOperator].join(),
            () => {
                this.kendoDataSource.filter(this.widgetOptions.filter)
            }
            ,{ deep: true }
        )

        this.$watch(
            () => [this.group, this.groupField, this.groupDir, this.groupAggregates].join(),
            () => {
                this.kendoDataSource.group(this.widgetOptions.group)
            },{ deep: true })

        this.$watch(
            () => [this.aggregate, this.aggregateAggregate, this.aggregateField].join(),
            () => {
                this.kendoDataSource.aggregate(this.widgetOptions.aggregate)
            },
            { deep: true })

        this.$watch(
            () => [this.sort, this.sortDir, this.sortField, this.sortCompare].join(),
            () => {
                this.kendoDataSource.sort(this.widgetOptions.sort)
            },{ deep: true })

        this.$watch(
            () => [this.page].join(),
            () => {
                this.kendoDataSource.page(this.widgetOptions.page)
            },{ deep: true })

        this.$watch(
            () => [this.pageSize].join(),
            () => {
                this.kendoDataSource.pageSize(this.widgetOptions.pageSize)
            },{ deep: true })

        this.$watch(
            () => [this.data].join(),
            () => {
                this.kendoDataSource.data(this.widgetOptions.data)
            },{ deep: true })
        
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/KendoDataSourceBaseMixin.js